import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Standard.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { NodeTypes, STEP_NODE_DESCRIPTION } from '../../utils';

export const StepNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Step' description={STEP_NODE_DESCRIPTION} nodeType={NodeTypes.STEP} imgPath={stepIcon} />
}